import request from "@/utils/request";

// Follow a company → it joins the user's "Following" list (the alert source). Distinct from /subscriptions (billing).
// Watchlist-management wrappers (create/update/delete/list/viewed) land with the management UI.
export const followCompanies = (data, options = {}) =>
  request({ url: "/watchlists/companies/add", method: "post", data, ...options });

export const unfollowCompanies = (data, options = {}) =>
  request({ url: "/watchlists/companies/delete", method: "delete", data, ...options });

export const queryFollowedCompanies = (data, options = {}) =>
  request({ url: "/watchlists/companies", method: "post", data, ...options });

export const setFollowFrequency = (data, options = {}) =>
  request({ url: "/watchlists/frequency", method: "post", data, ...options });
